import { render, staticRenderFns } from "./categoryDetails.vue?vue&type=template&id=1162dd37&"
import script from "./categoryDetails.vue?vue&type=script&lang=js&"
export * from "./categoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports